import ReactGA from 'react-ga4';

const measurementId = process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID;

export const initGA = (): void => {
  if (measurementId) {
    ReactGA.initialize(measurementId); // Initialize GA with the Measurement ID
  }
};

export const logPageView = (path: string): void => {
  if (measurementId) {
    ReactGA.send({
      hitType: 'pageview', // Log page view
      page: path
    });
  }
};
